export const toRichTextValueForEmbed = (value: string | null | undefined): string => {
  if (!value) {
    return '';
  }

  try {
    const parsed = JSON.parse(value) as {root?: unknown};
    if (parsed?.root) {
      return value;
    }
  } catch {
    // Fall through to wrap plain text as a minimal Lexical document.
  }

  return JSON.stringify({
    root: {
      direction: 'ltr',
      format: '',
      indent: 0,
      type: 'root',
      version: 1,
      children: [
        {
          children: [
            {
              detail: 0,
              format: 0,
              mode: 'normal',
              style: '',
              text: value,
              type: 'text',
              version: 1,
            },
          ],
          direction: 'ltr',
          format: '',
          indent: 0,
          type: 'paragraph',
          version: 1,
          textFormat: 0,
          textStyle: '',
        },
      ],
    },
  });
};

export const hasCanonicalWorkstreamDescription = (
  description: string | null | undefined
): description is string => description !== null && description !== undefined;

export const getWorkstreamTableDescriptionState = ({
  description,
}: {
  description: string | null | undefined;
}) => {
  const hasCanonicalDescription = hasCanonicalWorkstreamDescription(description);

  return {
    fallbackText: toRichTextValueForEmbed(description ?? ''),
    showDescription: hasCanonicalDescription && !!description,
  };
};
